/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConverter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 20v2H2v-2zM12 5.586l3.707 3.707-1.414 1.414L13 9.415v5.169l1.293-1.291 1.414 1.414L12 18.414l-3.707-3.707 1.414-1.414L11 14.584V9.415l-1.293 1.292-1.414-1.414zM22 2v2H2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgConverter as Converter };
